// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login_page_main_container {
  background-color: #c9d6ff;
  background: linear-gradient(to right, #e2e2e2, #c9d6ff);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex-direction: column;
  height: 100vh;
}

.container {
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.35);
  position: relative;
  overflow: hidden;
  width: 768px;
  max-width: 90%;
  min-height: 480px;
}

.container p {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  margin: 15px 0;
}

.container span {
  font-size: 12px;
}

.container a {
  color: #333;
  font-size: 13px;
  text-decoration: none;
  margin: 15px 0 10px;
  text-decoration: none;
  display: flex;
  justify-content: center;
}

.container button {
  background-color: orange;
  color: #fff;
  font-size: 12px;
  padding: 10px 45px;
  border: 1px solid transparent;
  border-radius: 8px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-top: 10px;
  cursor: pointer;
}

.container button:hover {
  background-color: #00a1ff;
}

.container button.hidden {
  background-color: transparent;
  border-color: #fff;
}

.container form {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.container input {
  background-color: #eee;
  border: none;
  margin: 8px 0;
  padding: 10px 15px;
  font-size: 13px;
  border-radius: 8px;
  width: 100%;
  outline: none;
}

.margin-bottom {
  margin-bottom: 0px !important;
}

.form-container {
  position: absolute;
  height: 100%;
  width: 50%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  transition: 0.8s ease-in-out;
}

.sign-in {
  left: 0;
  z-index: 2;
}

.container.active .sign-in {
  transform: translateX(100%);
}

.sign-up {
  left: 0;
  opacity: 0;
  z-index: 1;
}

.container.active .sign-up {
  transform: translateX(100%);
  opacity: 1;
  z-index: 5;
  animation: move 1.3s;
}

@keyframes move {
  0%,
  49.99% {
    opacity: 0;
    z-index: 1;
  }

  50%,
  100% {
    opacity: 1;
    z-index: 5;
  }
}

.toggle-container {
  position: absolute;
  top: 0;
  left: 50%;
  width: 50%;
  height: 100%;
  overflow: hidden;
  transition: all 0.6s ease-in-out;
  border-radius: 150px 0 0 100px;
  z-index: 1000;
}

.container.active .toggle-container {
  transform: translateX(-100%);
  border-radius: 0 150px 100px 0;
}

.toggle {
  background-color: linear-gradient(to left, #00a1ff, #00ff8f);
  height: 100%;
  background: linear-gradient(to right, #c33764, #1d2671);
  color: #fff;
  position: relative;
  left: -100%;
  height: 100%;
  width: 200%;
  transform: translateX(0);
  transition: all 0.6s ease-in-out;
}

.container.active .toggle {
  transform: translateX(50%);
}

.toggle-panel {
  position: absolute;
  width: 50%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 30px;
  text-align: center;
  top: 0;
  transform: translateX(0);
  transition: all 0.6s ease-in-out;
}
.toggle-panel-login,
.toggle-panel-sign-in {
  height: 83% !important;
}
.toggle-left {
  transform: translateX(-200%);
}

.container.active .toggle-left {
  transform: translateX(0);
}

.toggle-right {
  right: 0;
  transform: translateX(0);
}

.container.active .toggle-right {
  transform: translateX(200%);
}

.view-text {
  display: none;
}

.social-icons {
  margin: 20px 0;
}

.social-icons a {
  border: 1px solid #ccc;
  border-radius: 20%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 3px;
  width: 40px;
  height: 40px;
}

@media (max-width: 850px) {
  .form-container {
    width: 50%;
  }

  form {
    max-width: revert;
    padding: 1.5rem 2.5rem 2rem;
    transition: transform 0.8s ease-in-out, opacity 0.45s linear;
  }
}

@media (max-width: 530px) {
  .toggle-container {
    display: none;
  }

  .form-container {
    width: 100%;
  }

  form {
    padding: 1rem 2rem 1.5rem;
  }

  .container.active .sign-in {
    transform: translateX(-100%);
    transition: all 0.6s ease-in-out;
  }
}

.login_page_logo_container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 80%;
}

.leap-frog {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: var(--uib-size);
  height: var(--uib-size);
  padding: 8px 22px;
}

.leap-frog__dot {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 78%;
  height: 20px;
}

.leap-frog__dot::before {
  content: "";
  display: block;
  height: calc(var(--uib-size) * 0.22);
  width: calc(var(--uib-size) * 0.22);
  border-radius: 50%;
  background-color: var(--uib-color);
  will-change: transform;
}

.leap-frog__dot:nth-child(1) {
  animation: leapFrog var(--uib-speed) ease infinite;
}

.leap-frog__dot:nth-child(2) {
  transform: translateX(calc(var(--uib-size) * 0.4));
  animation: leapFrog var(--uib-speed) ease calc(var(--uib-speed) / -1.5)
    infinite;
}

.leap-frog__dot:nth-child(3) {
  transform: translateX(calc(var(--uib-size) * 0.8)) rotate(0deg);
  animation: leapFrog var(--uib-speed) ease calc(var(--uib-speed) / -3) infinite;
}

.forgot_password_text {
  color: #000000;
}

.reset_otp_box {
  margin-top: 2vh;
}

.forgot_password_send_mail {
  margin: 1vh 4vh 1vh 7vh;
  color: #000000 !important;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.login_button {
  padding: 0px !important;
  width: 80% !important;
  background-color: transparent !important;
  border: 1px solid white !important;
  color: white !important;
}
.login_button:hover {
  background-color: transparent !important;
  color: white !important;
}
.back-button {
  padding: 0px !important;
  width: 40%;
}`, "",{"version":3,"sources":["webpack://./src/styles/layout/login.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,MAAM;EACN,OAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE;;IAEE,UAAU;IACV,UAAU;EACZ;;EAEA;;IAEE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,4DAA4D;EAC5D,YAAY;EACZ,uDAAuD;EACvD,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,wBAAwB;EACxB,gCAAgC;AAClC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,2BAA2B;IAC3B,4DAA4D;EAC9D;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,4BAA4B;IAC5B,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oCAAoC;EACpC,mCAAmC;EACnC,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD;YACU;AACZ;;AAEA;EACE,+DAA+D;EAC/D,8EAA8E;AAChF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,wCAAwC;EACxC,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,wCAAwC;EACxC,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.login_page_main_container {\n  background-color: #c9d6ff;\n  background: linear-gradient(to right, #e2e2e2, #c9d6ff);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.container {\n  background-color: #fff;\n  border-radius: 30px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.35);\n  position: relative;\n  overflow: hidden;\n  width: 768px;\n  max-width: 90%;\n  min-height: 480px;\n}\n\n.container p {\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.3px;\n  margin: 15px 0;\n}\n\n.container span {\n  font-size: 12px;\n}\n\n.container a {\n  color: #333;\n  font-size: 13px;\n  text-decoration: none;\n  margin: 15px 0 10px;\n  text-decoration: none;\n  display: flex;\n  justify-content: center;\n}\n\n.container button {\n  background-color: orange;\n  color: #fff;\n  font-size: 12px;\n  padding: 10px 45px;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  margin-top: 10px;\n  cursor: pointer;\n}\n\n.container button:hover {\n  background-color: #00a1ff;\n}\n\n.container button.hidden {\n  background-color: transparent;\n  border-color: #fff;\n}\n\n.container form {\n  background-color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  height: 100%;\n}\n\n.container input {\n  background-color: #eee;\n  border: none;\n  margin: 8px 0;\n  padding: 10px 15px;\n  font-size: 13px;\n  border-radius: 8px;\n  width: 100%;\n  outline: none;\n}\n\n.margin-bottom {\n  margin-bottom: 0px !important;\n}\n\n.form-container {\n  position: absolute;\n  height: 100%;\n  width: 50%;\n  top: 0;\n  left: 0;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  transition: 0.8s ease-in-out;\n}\n\n.sign-in {\n  left: 0;\n  z-index: 2;\n}\n\n.container.active .sign-in {\n  transform: translateX(100%);\n}\n\n.sign-up {\n  left: 0;\n  opacity: 0;\n  z-index: 1;\n}\n\n.container.active .sign-up {\n  transform: translateX(100%);\n  opacity: 1;\n  z-index: 5;\n  animation: move 1.3s;\n}\n\n@keyframes move {\n  0%,\n  49.99% {\n    opacity: 0;\n    z-index: 1;\n  }\n\n  50%,\n  100% {\n    opacity: 1;\n    z-index: 5;\n  }\n}\n\n.toggle-container {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  transition: all 0.6s ease-in-out;\n  border-radius: 150px 0 0 100px;\n  z-index: 1000;\n}\n\n.container.active .toggle-container {\n  transform: translateX(-100%);\n  border-radius: 0 150px 100px 0;\n}\n\n.toggle {\n  background-color: linear-gradient(to left, #00a1ff, #00ff8f);\n  height: 100%;\n  background: linear-gradient(to right, #c33764, #1d2671);\n  color: #fff;\n  position: relative;\n  left: -100%;\n  height: 100%;\n  width: 200%;\n  transform: translateX(0);\n  transition: all 0.6s ease-in-out;\n}\n\n.container.active .toggle {\n  transform: translateX(50%);\n}\n\n.toggle-panel {\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 0 30px;\n  text-align: center;\n  top: 0;\n  transform: translateX(0);\n  transition: all 0.6s ease-in-out;\n}\n.toggle-panel-login,\n.toggle-panel-sign-in {\n  height: 83% !important;\n}\n.toggle-left {\n  transform: translateX(-200%);\n}\n\n.container.active .toggle-left {\n  transform: translateX(0);\n}\n\n.toggle-right {\n  right: 0;\n  transform: translateX(0);\n}\n\n.container.active .toggle-right {\n  transform: translateX(200%);\n}\n\n.view-text {\n  display: none;\n}\n\n.social-icons {\n  margin: 20px 0;\n}\n\n.social-icons a {\n  border: 1px solid #ccc;\n  border-radius: 20%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 3px;\n  width: 40px;\n  height: 40px;\n}\n\n@media (max-width: 850px) {\n  .form-container {\n    width: 50%;\n  }\n\n  form {\n    max-width: revert;\n    padding: 1.5rem 2.5rem 2rem;\n    transition: transform 0.8s ease-in-out, opacity 0.45s linear;\n  }\n}\n\n@media (max-width: 530px) {\n  .toggle-container {\n    display: none;\n  }\n\n  .form-container {\n    width: 100%;\n  }\n\n  form {\n    padding: 1rem 2rem 1.5rem;\n  }\n\n  .container.active .sign-in {\n    transform: translateX(-100%);\n    transition: all 0.6s ease-in-out;\n  }\n}\n\n.login_page_logo_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  width: 80%;\n}\n\n.leap-frog {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: var(--uib-size);\n  height: var(--uib-size);\n  padding: 8px 22px;\n}\n\n.leap-frog__dot {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 78%;\n  height: 20px;\n}\n\n.leap-frog__dot::before {\n  content: \"\";\n  display: block;\n  height: calc(var(--uib-size) * 0.22);\n  width: calc(var(--uib-size) * 0.22);\n  border-radius: 50%;\n  background-color: var(--uib-color);\n  will-change: transform;\n}\n\n.leap-frog__dot:nth-child(1) {\n  animation: leapFrog var(--uib-speed) ease infinite;\n}\n\n.leap-frog__dot:nth-child(2) {\n  transform: translateX(calc(var(--uib-size) * 0.4));\n  animation: leapFrog var(--uib-speed) ease calc(var(--uib-speed) / -1.5)\n    infinite;\n}\n\n.leap-frog__dot:nth-child(3) {\n  transform: translateX(calc(var(--uib-size) * 0.8)) rotate(0deg);\n  animation: leapFrog var(--uib-speed) ease calc(var(--uib-speed) / -3) infinite;\n}\n\n.forgot_password_text {\n  color: #000000;\n}\n\n.reset_otp_box {\n  margin-top: 2vh;\n}\n\n.forgot_password_send_mail {\n  margin: 1vh 4vh 1vh 7vh;\n  color: #000000 !important;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.login_button {\n  padding: 0px !important;\n  width: 80% !important;\n  background-color: transparent !important;\n  border: 1px solid white !important;\n  color: white !important;\n}\n.login_button:hover {\n  background-color: transparent !important;\n  color: white !important;\n}\n.back-button {\n  padding: 0px !important;\n  width: 40%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
